const illustrations = {
  digital: (
    <>
      <rect x="7" y="11" width="50" height="42" rx="5" />
      <path d="M7 21h50M15 16h2m4 0h2" />
      <rect x="15" y="29" width="15" height="16" rx="2" />
      <path d="M36 31h12M36 38h12M36 45h8" />
    </>
  ),
  systems: (
    <>
      <rect x="22" y="22" width="20" height="20" rx="3" />
      <rect x="4" y="5" width="13" height="13" rx="2" />
      <rect x="47" y="5" width="13" height="13" rx="2" />
      <rect x="4" y="46" width="13" height="13" rx="2" />
      <rect x="47" y="46" width="13" height="13" rx="2" />
      <path d="M17 12h15v10M47 12H32m0 30v10H17m30 0H32V42" />
    </>
  ),
  iot: (
    <>
      <circle cx="32" cy="34" r="6" />
      <path d="M20 23a17 17 0 0 1 24 0M15 17a25 25 0 0 1 34 0M20 45a17 17 0 0 0 24 0M15 51a25 25 0 0 0 34 0" />
      <path d="M32 40v10" />
    </>
  ),
  architecture: (
    <>
      <path d="m32 5 23 13v28L32 59 9 46V18L32 5Z" />
      <path d="m9 18 23 13 23-13M32 31v28M19 25l23-13M19 39l13 7 13-7" />
    </>
  ),
};

export default function ServiceIllustration({ kind }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        {illustrations[kind]}
      </g>
    </svg>
  );
}
